export default __webpack_public_path__ + "9cc0993ee9faf5ea182df355ae6f56b9.png";